<template>
    <div>  
        <b-table 
            ref="virtualStopsTable"
            striped 
            hover 
            selectable 
            select-mode="single" 
            @row-selected="onRowSelected"  
            :items="computedItems" 
            :fields="fields" 
            :filter="filter"
            @filtered="onFiltered"
            :per-page="perPage"
            :current-page="currentPage">
        </b-table>
    
        <TablePagination 
        :total-rows="totalRows" 
        :per-page="perPage" 
        @pageChange="onPageChange">
        </TablePagination>
  
    </div>        
</template>

<script>

import TablePagination from '@/components/Misc/TablePagination'
import virtualStops from '@/store/system/virtualStops'

export default {
    name: 'VirtualStopsTable',
    components: { TablePagination },
    props: ['filter'],
    data: function() {
        return {
            perPage: 10,
            currentPage: 1,
            filteredRows: 0,
            computedItems: [],
            fields: [
                { key:"original.description" , label: this.$t('virtual_stops.descriptions')},
                { key:"mergedCoordinates", label: this.$t('virtual_stops.coordinates')}
                ],
        }
    },
    computed: {
        items () { 
            if(this.$store.state.virtualstops){
                return this.$store.state.virtualstops.virtualStopsList;
            }else{
                return [];
            }
            
        },
        totalRows() {
            return this.filteredRows ? this.filteredRows : (this.items ? this.items.length : 0);
        }
    },
    created() {
        if (!this.$store.state.virtualstops) {
            this.$store.registerModule("virtualstops" , virtualStops);
        }
        
        this.$store.dispatch('virtualstops/getVirtualStops').then(
        (response) => {
            this.ok = response.data ? response.data.errorCode == 0 : false;
            this.error = !this.ok
            this.loading = false
        },
        ()=>{ 
            this.error = true; 
        });
    },
    methods: {
        onRowSelected (items) {
            this.$emit('selectItem', items[0].original);        
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            this.currentPage = 1;
        },
        onPageChange(page){
            this.currentPage = page;
        }
    },
    watch:{
        items() {
            if(this.$store.state.virtualstops && this.$store.state.virtualstops.virtualStopsList) {
                this.computedItems = []; 

                this.$store.state.virtualstops.virtualStopsList.forEach( virtualStop => {
                    let computedItem = {};
                    computedItem.original = virtualStop;
                    computedItem.mergedCoordinates = virtualStop.latitude + ", " + virtualStop.longitude;
                    this.computedItems.push( computedItem )
                });
            }
        }
    } 
}

</script>
